import ReactApexChart from 'react-apexcharts';
import { Box, Typography, useTheme } from '@mui/material';

export default function ChartBlock({ block }) {
  const theme = useTheme();
  const { title, categories = [], series = [] } = block;
  const chartType = block.chart_type || 'bar';

  const options = {
    chart: { toolbar: { show: false }, background: 'transparent' },
    theme: { mode: theme.palette.mode },
    xaxis: { categories },
    stroke: { curve: 'smooth', width: chartType === 'line' ? 2 : 0 },
    fill: { opacity: 1 },
    legend: { position: 'bottom' },
    dataLabels: { enabled: false },
    tooltip: { theme: theme.palette.mode },
    colors: [
      theme.palette.primary.main,
      theme.palette.secondary.main,
      theme.palette.warning.main,
      theme.palette.error.main,
    ],
  };

  if (chartType === 'pie' || chartType === 'donut') {
    const labels = series[0]?.labels || categories;
    const data = series[0]?.data || series;
    return (
      <Box sx={{ my: 1.5 }}>
        {title && <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>{title}</Typography>}
        <ReactApexChart
          type={chartType}
          series={data}
          options={{ ...options, labels, legend: { position: 'bottom' } }}
          height={280}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ my: 1.5 }}>
      {title && <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>{title}</Typography>}
      <ReactApexChart
        type={chartType}
        series={series}
        options={options}
        height={260}
      />
    </Box>
  );
}
